import React from "react";
import { Button } from "@mui/material";
import "../../../styles/Layout/Admin_Styles/_AdminConfirmationDetails.scss";
// import { fDate } from "../../../utils/formatTime";

import { useNavigate } from "react-router-dom";
import HeaderLogoImage from "../../../assets/pdf-logo.png";
import PaymentSlip from "../../../components/Dashboard/PaymentConfirmationDetails/PaymentSlip/PaymentSlip";

const AdminConfirmationDetails = (_props) => {
  const { appliedPost, paymentDetails, email } = _props
  const navigate = useNavigate()

  return (
    <div className="admin-confirmation" id="admin-confirmation">

      <div className="print-logo2">
        <div className="headerImg">
          <img src={HeaderLogoImage} alt="ExamImg" />
        </div>
      </div>

      <PaymentSlip
        className={"admin-confirmation"}
        paymentDetails={paymentDetails}
        appliedPost={appliedPost}
        email={email}
      />

      <div className="admin-confirmation--buttons">
        <div className="admin-confirmation--button1">
          <Button variant="contained" onClick={() => {
            const element = document.getElementById('admin-confirmation');
            if (element) {
              window.print(element);
            }
          }}>Print Reciept</Button>
        </div>
        {/* {paymentDetails?.order_status === 'Success' &&
          <div className="admin-confirmation--button2">
            <Button variant="contained" onClick={() => {
              navigate(`${paths?.front?.commonPoint !== '/' ? `${paths?.front?.commonPoint}/` : paths?.front?.commonPoint}${paths?.front?.user?.finalconfirmation}`)
              window.scrollTo(0, 0)
            }}>Download Application Form</Button>
          </div>
        } */}

      </div>

    </div>
  );
};

export default AdminConfirmationDetails;
